import { DownOutlined, LogoutOutlined } from "@ant-design/icons";
import { Affix, Button, Dropdown, Layout, Menu } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdLanguage } from "react-icons/md";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import i18n from "../../i18n";
import LogoEverience from "../../image/everience-logo.png";
import { getDefaultLanguage } from "../../utils/functions";
import { getTokenDecode } from "../../utils/security";
import styles from "./index.module.css";

const { Header } = Layout;
const { Item: MenuItem } = Menu;

const Navbar = () => {
  const changeLanguage = (lng) => {
    sessionStorage.setItem("language", lng);
    i18n.changeLanguage(lng);
  };

  const { t } = useTranslation();
  const history = useHistory();

  const [ssoInfo, setSsoInfo] = useState("");
  const { token } = useSelector((state) => state.auth);

  useEffect(() => {
    if (sessionStorage.getItem("language") === null || sessionStorage.getItem("language") === undefined) {
      sessionStorage.setItem("language", getDefaultLanguage());
    }
  }, []);

  useEffect(() => {
    if (token) {
      const decoded = getTokenDecode(token);
      if (decoded) {
        return setSsoInfo(decoded.given_name + " " + decoded.family_name);
      }
    }
    setSsoInfo("");
  }, [token]);

  const translationMenu = (
    <Menu>
      <MenuItem key="1" onClick={() => changeLanguage("fr")}>
        Français
      </MenuItem>
      <MenuItem key="2" onClick={() => changeLanguage("en")}>
        English
      </MenuItem>
    </Menu>
  );

  const profilMenu = (
    <Menu>
      <MenuItem
        key="1"
        icon={<LogoutOutlined />}
        onClick={() => {
          history.push("/logout");
        }}
      >
        {t("logout.button")}
      </MenuItem>
    </Menu>
  );
  return (
    <Header className="header">
      <Affix offsetTop={0}>
        <nav className="navbar">
          <div className={styles.navbar__container}>
            <img
              id="logoEverience"
              className={styles.navbar__brand}
              src={LogoEverience}
              alt="Logo"
              onClick={() => {
                sessionStorage.clear();
                window.location.replace("/");
              }}
            />
            <div>
              <Dropdown overlay={translationMenu} trigger="click">
                <Button type="text">
                  <MdLanguage /> <DownOutlined />
                </Button>
              </Dropdown>
              {token && (
                <Dropdown overlay={profilMenu} trigger="click">
                  <Button type="text">
                    <span className="sso-info">{ssoInfo}</span> <DownOutlined />
                  </Button>
                </Dropdown>
              )}
            </div>
          </div>
        </nav>
      </Affix>
    </Header>
  );
};

export default Navbar;
